import { __read } from 'tslib';
import React__default, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { Dismiss } from '../../assets/icons/Dismiss.esm.js';
import { NvMarkdownInline, NvButton } from '@invitae/ids-react';
import { BaseNucleobaseComponent } from '@invitae/nucleobase-core';
import styles from './NotificationBanner.module.esm.js';

var NotificationBanner = function (_a) {
    var _b = _a.fields, code = _b.code, body = _b.body, link = _b.link, image = _b.image, dismissible = _b.dismissible, dismissals = _b.dismissals;
    var _c = __read(useState(true), 2), isVisible = _c[0], setIsVisible = _c[1];
    var sessionKey = "bannerDismissed_".concat(code);
    var localKey = "bannerDismissalCount_".concat(code);
    useEffect(function () {
        // Check if the banner was dismissed in this session
        var sessionDismissed = sessionStorage.getItem(sessionKey);
        if (sessionDismissed === 'true') {
            setIsVisible(false);
            return;
        }
        // Check the dismissal count in localStorage
        var dismissalCount = parseInt(localStorage.getItem(localKey) || '0', 10);
        // If the count has reached the dismissals setting for the banner, do not show the banner
        if (dismissalCount >= dismissals) {
            setIsVisible(false);
        }
    }, [sessionKey, localKey, dismissals]);
    var close = function () {
        // Mark as dismissed in this session
        sessionStorage.setItem(sessionKey, 'true');
        // Update the dismissal count in localStorage
        var currentCount = parseInt(localStorage.getItem(localKey) || '0', 10);
        localStorage.setItem(localKey, (currentCount + 1).toString());
        // Hide the banner
        setIsVisible(false);
    };
    return (React__default.createElement("dialog", { className: classNames(styles.root, 'hide-in-percy'), "data-code": code, open: isVisible },
        React__default.createElement("div", { className: classNames('nv-container', styles.wrapper) },
            React__default.createElement("div", { className: styles.content },
                image && (React__default.createElement("div", { className: styles.image },
                    React__default.createElement(BaseNucleobaseComponent, { maxImageWidth: 300, source: image }))),
                React__default.createElement("p", { className: styles.body },
                    React__default.createElement(NvMarkdownInline, { elementWrapper: "span" }, body),
                    link && (React__default.createElement("span", { className: styles.link },
                        "\u00A0",
                        React__default.createElement(BaseNucleobaseComponent, { source: link }))))),
            dismissible && (React__default.createElement("div", { className: styles.dismiss },
                React__default.createElement(NvButton, { className: styles.closePanel, onClick: close, size: "small", variant: "plain" },
                    React__default.createElement(Dismiss, null)))))));
};

export { NotificationBanner as default };
//# sourceMappingURL=NotificationBanner.esm.js.map
